export function formatDate(time) {
  return time
}
// 身份证去掉多余的*
export function removeTheExcessFromTheIDCard(val) {
  let cardNoList = val.split('*')
  if (cardNoList.filter(item => item == '').length > 16) {
    let carNO = [...new Set(cardNoList)]
    carNO.map((item, index) => {
      if (!item) {
        carNO[index] = '****************'
      }
    })
    return carNO.toString().replaceAll(',', '')
  }
  else {
    return val
  }
}

